// extracted by mini-css-extract-plugin
export var locationCard = "_fm-0";